import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Lock, Download, RotateCcw } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full bg-marfil py-16 px-5 flex justify-center" data-id="element-28">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} className="w-full max-w-md flex flex-col items-center text-center gap-6" data-id="element-29">
        <h2 className="font-serif font-bold text-petroleo text-3xl leading-tight" data-id="element-30">
          Tu cuerpo lleva años esperando esto.
        </h2>

        <div className="w-full mt-2" data-id="element-31">
          <CTAButton text="Quiero mi Protocolo — $19.990" isCheckout={true} data-id="element-32" />
        </div>

        <div className="flex flex-col gap-3 mt-4 w-full bg-white p-5 rounded-xl border border-salvia-light shadow-sm" data-id="element-33">
          <div className="flex items-center gap-3 text-gray-700 text-sm font-medium" data-id="element-34">
            <Lock className="w-4 h-4 text-salvia" data-id="element-35" />
            <span data-id="element-36">Pago seguro con Mercado Pago</span>
          </div>
          <div className="flex items-center gap-3 text-gray-700 text-sm font-medium" data-id="element-37">
            <Download className="w-4 h-4 text-salvia" data-id="element-38" />
            <span data-id="element-39">Descarga inmediata al instante</span>
          </div>
          <div className="flex items-center gap-3 text-gray-700 text-sm font-medium" data-id="element-40">
            <RotateCcw className="w-4 h-4 text-salvia" data-id="element-41" />
            <span data-id="element-42">Garantía de devolución 7 días</span>
          </div>
        </div>
      </motion.div>
    </section>;
}